import ClientInformationVertical from '../../components/History/ClientInformationVertical';
import EvaluationPlanForLocation from '../../components/History/EvaluationPlanForLocation';
import { Divider, NavigateBack, Typography } from '../../designComponents';
import { ViewJobContainerStyled } from '../BrowseJobs/BrowseJobDetails/style';

const PrinterHistory = () => {
  return (
    <ViewJobContainerStyled>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <Typography variant="title">History</Typography>
        <Divider spaceY="20px" />
        <ClientInformationVertical
          user="Your"
          userName="Sachin Bhattrai"
          email="SachinBhattrai12@gmail.com"
          role="Printer"
        />
        <Divider spaceY="20px" />
        <EvaluationPlanForLocation location="Hotel" />
        <Divider spaceY="20px" />
        <EvaluationPlanForLocation location="School" />
        <Divider spaceY="20px" />
        <EvaluationPlanForLocation location="Mall" />
        <Divider spaceY="20px" />
      </div>
    </ViewJobContainerStyled>
  );
};

export default PrinterHistory;
